<template>
    <div>
 
      <section  class="navbarsection" style="margin-top: -50px;">
            <div class="txtdata">
              <h1  style="padding-top: 200px;"></h1>
            </div>
              <div class="videosection" >
                <div  v-show="pvisvideo === true && pvpictureimage === false ">
                  <Transition class="transition thing">
                    <video-background 
                      playbackRate=0.98
                      :src="src"
                      :poster="poster"
                      :class="`thing playercss`"
                      :style="`height: 600px;`">
                    </video-background>
                  </Transition>
                </div>
              
                  <div id="panorama"  v-show="pvisvideo === false && pvpictureimage === true"  :style="`height: 600px; padding-top: -5px;`">
                  </div>
        
                  <img :src="poster" style="width: 100%; height: 600px;" class="imgcss" 
                  v-show="pvisvideo === false && pvpictureimage === false || pvisvideo === true && pvpictureimage === true" />
         
            </div>
            <div class="overlay"></div>
            <div style="margin-top: -200px; color: white; margin-left: 50px; margin-bottom: 300px;">
              <h1 class="" v-html="imagetext" :class="formatvhtml"></h1>
            </div>
          </section>
    

    <StockCards :getstocks="getstocks" stocktheme="stockcss"/>
 
    

    <!-- <div>
    <AllCardsext :cvdesc="envcardcaption"  :valuesphotos="valuesphotosabout" :cvpurposevaluelinkname="cvpurposevaluelinkname" :cvlink="cvlink" 
    allcardsexttheme='allcardsextsection' :cvvisibility="cvvisibility" :cardnumber="cardnum1"/>
    </div> -->
<!-- 
    <AllNews :homepagenews="homepagenews" :newsphoto="newsphoto" /> -->

    <div class="youtubecss">
      <YoutubeVideoplayer :youtubevideopath="youtubevideopath" :coverpage="coverpage" :topmessage="topmessage" />
    </div>
  
    <!-- <div>
      <UpcomingeventPresentation :eventdata="eventdata" :presentdata="presentdata" presentationtheme="presentationcss"/>
    </div> -->
   
  
    <!-- <TwoReportsection :tworeportdata="investpagereport" /> -->

    <ThreecardsSection :allcardsdata="contdata" />

    <AllSlides :displayedPhotos="displayedPhotos" :ophotos="ophotos" :page="page" :perPage="perPage" 
    :pages="pages" :totalPages="totalPages" allslidestheme="allslidescss" />


    <TwoEqualsections :secquestion="investquestion" :seconetext="investquesttext1" :sectwotext="investquesttext2" />
    
    <div style="padding: 100px;">
      <hr />
      <div v-html="bottomtext" style="text-align: center;">
      
      </div>
    </div>
     
    </div>
  </template>
  
  <script>

  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import AllSlides from '@/components/AllSlides.vue';
  import StockCards from '@/components/StockCards.vue';
  import AllCardsext from '@/components/AllCardsext.vue';
  import AllNews from '@/components/AllNews.vue';
  import YoutubeVideoplayer from '@/components/YoutubeVideoplayer.vue';
  import ThreecardsSection from '@/components/ThreecardsSection.vue';
  import TwoEqualsections from '@/components/TwoEqualsections.vue';
  import TwoReportsection from '@/components/TwoReportsection.vue';
  import UpcomingeventPresentation from '@/components/UpcomingeventPresentation.vue';
 
  require('@/assets/css/pannellium-2.5.css');
  require('@/assets/css/video-js.css');
  require('@/globalDeclare.js');
  import Chart from 'chart.js/auto';
  import axios from 'axios';
  
  
  export default {
    name: 'AboutView',
    components: {
    BreadCrumbs, AllSlides, StockCards, AllCardsext, AllNews, YoutubeVideoplayer, 
     ThreecardsSection, TwoEqualsections, TwoReportsection, UpcomingeventPresentation
  },
  data() {
    return {
    videoimage: [],
    imagetext: '',
    src: '',
    playrate: '',
    poster: '',
    // pvwebm: '',
    // pvmp4: '',
    pvstyle: '',
    pvsrc: '',
    pvisvideo: false,
    pvpanorama1: '',
    pvpanorama2: '',
    pvpanorama3: '',
    pvhotspot1: '',
    pvhotspot2: '',
    pvhotspot3: '',
    showVideo: false,
    showPanorama: false,
    picurl: myUrlPath,
  

    getpurpose: [],
    allyears: [],
    yearimages: [],
    contfluiddata: [],
    allcardsdata: [],
    contdata: [],
    aboutgeneral: [],
    envcardcaption: '',
    cvvisibility: true,
    cardnum1: 2,

      //pagination props
    ophotos: [],
    page: 1,
    perPage: 1,
    pages: [],
    totalPages: 0,
    displayedPhotos: [],


    youtubeheight: '600px',
    youtubewidth: '800px',
  

    newsphotos: [],
    newsphoto: '',

    bottomtext: '',

    getstocks: [],

    investpagereport: [],

    investquestion: '',
    investquesttext1: '',
    investquesttext2: '',

    youtubevideopath: '',
    coverpage: '',
    topmessage: '',

    contdata: [],

    eventdata: [],
    presentdata: [],
    
  
    reportpresentation: [],
    lastrecordsreportpresent: [],
    myPicUrl: '',
  
    gcolorcodes: [],
    breadcrumbsinfo: [],
  
    height: 0,
    width: 0,
    }
  },
  methods: {
    async getPhotos() {
    await axios.get('homepageotheruploadlisting/investoverview').then(
          response => {
          this.ophotos = response.data;
          this.totalPages = response.data.length;
        })
        .catch(response => {
            console.log(response);
        });
    },
},
created() {
        this.getPhotos();
    },
mounted() {
    this.myPicUrl = myUrlPath
  axios.get('allpagespv/investoverview').then(
      response => {
        this.videoimage = response.data
        
        this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.picurl + this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.picurl + this.videoimage.pvposter
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.picurl + this.videoimage.pvpanorama1
      this.pvpanorama2 = this.picurl + this.videoimage.pvpanorama2
      this.pvpanorama3 = this.picurl + this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3
      this.pvpictureimage = this.videoimage.pvpictureimage
  
        // let pvisvideo1 = this.videoimage.pvisvideo
        // this.pvisvideo = pvisvideo1
  
  
        if (this.pvisvideo === 'true') {
          this.src = this.videoimage.pvmp4
          this.showVideo
          if (response.status === 403 ) {
          e = "No data available"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
          });
          }
          else if (response.status === 404) {
            e = "Page Not Found!"
            const toast = useToast();
            toast.success(e, {
            timeout: 6000
          });
          }
        }
        else{
            const config = {
            autoLoad: true,
            scenchange: true,
            compass: false,
            northOffset: -237.5,
            default: {
                firstScene: "hotspotoffice",
                sceneFadeDuration: 1000,
                autoRotate: -.6,
                setTimeout: 100,
                preview: this.poster
                
            },
            scenes: {
                hotspotoffice: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 0,
                    type: "equirectangular",
                    panorama: this.pvpanorama1,
                    hotSpots: [
                        {
                            pitch: 4,
                            yaw: 21.8,
                            type: "scene",
                            sceneId: "anotherhotspot",
                            text: this.pvhotspot1,
                        }
                    ]
                },
                anotherhotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama2,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "lasthotspot",
                              text: this.pvhotspot2,
                          }
                      ]
                  },
                  lasthotspot: {
                      hfov: 180,
                      pitch: 0,
                      yaw: 90,
                      type: "equirectangular",
                      panorama: this.pvpanorama3,
                      hotSpots: [
                          {
                              pitch: 8,
                              yaw: -58,
                              type: "scene",
                              sceneId: "hotspotoffice",
                              text: this.pvhotspot3,
                          }
                      ]
                  },
                
              }
          };
          pannellum.viewer('panorama', config);
        }
        console.log(this.src)
    })
    .catch((error) => {
          console.log(error)
        })

  
  //-----------Homepage News section-------------
  axios.get('homepagenewslisting/').then(
      response => {
          this.homepagenews = response.data.results
    })
    .catch((error) => {
        console.log(error)
      })

  //-----------Homepage NewsPhoto section-------------
  axios.get('newsphotos/').then(
      response => {
          this.newsphotos = response.data
          this.newsphoto = response.data[0]['newsphoto']
    })
    .catch((error) => {
        console.log(error)
      })   
  //---------------AllCardsext -------------------------
  axios.get('valuesphotos/products').then(
        response => {
            this.valuesphotosabout = response.data
    })
    .catch((error) => {
        console.log(error)
        })
  //---------------AllCardsext -------------------------
  axios.get('getcardcaption/investoverview').then(
          response => {
              this.envcardcaption = response.data[0].captiondesc
      })
      .catch((error) => {
          console.log(error)
          })
     //------------Homepage Stock Prices---------------
  axios.get('stockprices/homepage').then(
        response => {
            this.getstocks = response.data
    })
    .catch((error) => {
        console.log(error)
        })
  
    //------------Home videos---------------
  axios.get('getyoutubevideo/investoverview').then(
        response => {
        this.youtubevideopath = this.myPicUrl + response.data[0].uploadyv
        this.coverpage = this.myPicUrl + response.data[0].coverpage
        this.topmessage = response.data[0].yvdesc
        
    })
    .catch((error) => {
        console.log(error)
        })
  
        //------------breadcrumbs mappings info---------------
  axios.get('getbreadcrumbsinfo/investoverview').then(
        response => {
            this.breadcrumbsinfo = response.data

    })
    .catch((error) => {
        console.log(error)
        })
  
  //------------Three card section data---------------
  axios.get('getallcardsectionsdata/products').then(
    response => {
        this.contdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //-----------All invest page report data--------------
  axios.get('getinvestinfo/').then(
    response => {
        this.investpagereport = response.data
        this.investquestion = response.data[0].invquesttext
        this.investquesttext1 = response.data[0].invoverviewquestsec1
        this.investquesttext2 = response.data[0].invoverviewquestsec2
    })
  .catch((error) => {
      console.log(error)
    })

   //------------upcoming events---------------
   axios.get('geteventlist/investoverview').then(
    response => {
        this.eventdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  //------------upcoming Presentation Pictures---------------
  axios.get('geteventcaption/investoverview').then(
    response => {
        this.presentdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })

  }
  }
  </script>
  
  <style scoped>
 
  .section03 {
    height: 300px;
  }
  .container {
    display: grid;
    height: 100vh;;
    grid-template-columns: 1fr;
    grid-template-rows: .2fr 1.2fr .2fr;
    grid-template-areas: 
    "nav nav nav" 
    "main main main" 
    "footer footer footer";
    grid-gap: 0.2rem;
    font-family: "Inter", sans-serif;
    font-size: 800;
    font-size: 12px;
    color: #234234;
    text-align: center;
  }
  
  html { 
    height: 100%;
    margin:0px;
    background: url('../assets/slide-5.jpg') no-repeat center center;
    background-size: cover;
    background-attachment: fixed;
  }
  
  main {
    background: white;
    grid-area: main;
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
    border-radius: 0px;
    margin-top:-5px;
  }
  .formatrow {
    margin-top: 340px;
    padding-left: 100px;
    padding-right: 100px;
  }
  .seven3css {
    margin-top: 100px;
  }
  
  .reportpresentcss {
    margin-top: 300px;
  }
  .imagecss {
    width: 80%;
    padding-left: 50px;
    padding-bottom: 100px;
  }
  .pushsection {
    margin-top: -100px;
    background-color: white;
    padding: 30px;
  }
  .seven3css {
    width: 84%;
    margin: 0 auto;
    margin-top: 200px;
  }
  .breadcrumcss {
    margin-top: -200px;
  }

  .stockcss {
    margin-bottom: -10px;
  }
  .upcomingeventsp {
    padding-left: 100px;
    padding-right: 100px;
  }
 .presentationcss {
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #003;
 }
 .allslidescss {
  background-color: azure;
  margin-top: -100px;
 }
 .videosection {
  margin-top: -60px;
  height: 600px;
  width: 100%;
  background-color: #003;
}

 .overlay {
  opacity: 0.99;
  width: 100%;
  height: 600px;
  background: linear-gradient(to bottom, #003, transparent);
  margin-top: -600px;

}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
  @media only screen and (max-width: 600px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
      .reportpresentcss {
        margin-top: 600px;
      }
      .stockcss {
        width: 90%;
        margin: 20px;
        margin-top: 100px;
      }
 
  }
  
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
      .stockcss {
        width: 100%;
        margin-top: 100px;
        margin: 0 auto;
        padding: 20px;   
      }
 
  }
  
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .imagecss {
        width: 90%;
        margin: 0 auto;
        padding-bottom: 100px;
      }
     

      .stockcss {
        width: 70%;
        margin-top: 100px;
        margin: 0 auto;
      }
 
  }
  
  
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .stockcss {
      width: 70%;
      margin-top: 100px;
      margin: 0 auto;
    }
 
  }
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  .slidercss {
    margin-bottom: 300px;
  }
  
  }
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {

  }
  
   /* Extra large devices (large laptops and desktops, 1200px and up) */
   @media only screen and (min-width: 1600px) {
  
  }
  </style>
  